import { MatDateFormats } from '@angular/material/core';

export const CD_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'YYYY-MM-DD', // Parsing format
  },
  display: {
    dateInput: 'YYYY-MM-DD', // Format displayed in input
    monthYearLabel: 'MMM YYYY', // Format in month-year picker
    dateA11yLabel: 'LL', // Accessible label
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
